import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { dashboardApiConfig } from 'src/config';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Grid,
  Box,
  Button,
  makeStyles,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  FormHelperText,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  MenuItem, 
  Select, 
  hexToRgb,
  Paper 
} from '@material-ui/core';
import wait from 'src/utils/wait';
import { withStyles, styled  } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';

import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

import track from 'src/utils/analytics';
import { Link as RouterLink } from 'react-router-dom';


const StyledTextField = styled(TextField, {
  name: "StyledTextField",
})({
  width: '200%',
  '@media (max-width: 600px)': {
    width: '100%', 
  },
});


const Accordion = withStyles({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);


const AccordionSummary = withStyles({
  root: {
    backgroundColor: '#474343',
    color: '#ffffff',
    
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {color: '#ffffff',},
})(MuiAccordionSummary);


const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);


const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    padding: '2px 2px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
    height: 65
  },
  divider: {
    height: 30,
    margin: 5
  },
  cardHeader: {
    color: hexToRgb('#787878')
  },
}));


const WhatsappQRCode = ({ className, text, format, qrcodeName, ...rest }) => {
  const classes = useStyles();
  const [img, setImg] = useState();
  const [expanded, setExpanded] = React.useState('expand_whatsapp');

  const whatsapp_accordioan = (whatsappaccordioan) => (event, newExpanded) => {
    setExpanded(newExpanded ? whatsappaccordioan : false);
  };

  const [light, setLight] = useState('#ffffff');
  const [dark, setDark] = useState('#050505');


  const [selectedCountry, setSelectedCountry] = useState('');
  const countries = [

  { code: '+93', name: 'Afghanistan', callingCode: 'AF' },
  { code: '+355', name: 'Albania', callingCode: 'AL' },
  { code: '+213', name: 'Algeria', callingCode: 'DZ' },
  { code: '+1', name: 'American Samoa', callingCode: 'AS' },
  { code: '+376', name: 'Andorra', callingCode: 'AD' },
  { code: '+244', name: 'Angola', callingCode: 'AO' },
  { code: '+1', name: 'Anguilla', callingCode: 'AI' },
  { code: '+1', name: 'Antigua and Barbuda', callingCode: 'AG' },
  { code: '+54', name: 'Argentina', callingCode: 'AR' },
  { code: '+374', name: 'Armenia', callingCode: 'AM' },
  { code: '+297', name: 'Aruba', callingCode: 'AW' },
  { code: '+61', name: 'Australia', callingCode: 'AU' },
  { code: '+43', name: 'Austria', callingCode: 'AT' },
  { code: '+994', name: 'Azerbaijan', callingCode: 'AZ' },


  { code: '+1', name: 'Bahamas', callingCode: 'BS' },
  { code: '+973', name: 'Bahrain', callingCode: 'BH' },
  { code: '+880', name: 'Bangladesh', callingCode: 'BD' },
  { code: '+1', name: 'Barbados', callingCode: 'BB' },
  { code: '+375', name: 'Belarus', callingCode: 'BY' },
  { code: '+32', name: 'Belgium', callingCode: 'BE' },
  { code: '+501', name: 'Belize', callingCode: 'BZ' },
  { code: '+229', name: 'Benin', callingCode: 'BJ' },
  { code: '+1', name: 'Bermuda', callingCode: 'BM' },
  { code: '+975', name: 'Bhutan', callingCode: 'BT' },
  { code: '+591', name: 'Bolivia', callingCode: 'BO' },
  { code: '+387', name: 'Bosnia and Herzegovina', callingCode: 'BA' },
  { code: '+267', name: 'Botswana', callingCode: 'BW' },
  { code: '+55', name: 'Brazil', callingCode: 'BR' },
  { code: '+246', name: 'British Indian Ocean Territory', callingCode: 'IO' },
  { code: '+1', name: 'British Virgin Islands', callingCode: 'VG' },
  { code: '+673', name: 'Brunei', callingCode: 'BN' },
  { code: '+359', name: 'Bulgaria', callingCode: 'BG' },
  { code: '+226', name: 'Burkina Faso', callingCode: 'BF' },
  { code: '+257', name: 'Burundi', callingCode: 'BI' },


  { code: '+855', name: 'Cambodia', callingCode: 'KH' },
  { code: '+237', name: 'Cameroon', callingCode: 'CM' },
  { code: '+1', name: 'Canada', callingCode: 'CA' },
  { code: '+238', name: 'Cape Verde', callingCode: 'CV' },
  { code: '+236', name: 'Central African Republic', callingCode: 'CF' },
  { code: '+235', name: 'Chad', callingCode: 'TD' },
  { code: '+56', name: 'Chile', callingCode: 'CL' },
  { code: '+86', name: 'China', callingCode: 'CN' },
  { code: '+61', name: 'Christmas Island', callingCode: 'CX' },
  { code: '+61', name: 'Cocos Islands', callingCode: 'CC' },
  { code: '+57', name: 'Colombia', callingCode: 'CO' },
  { code: '+269', name: 'Comoros', callingCode: 'KM' },
  { code: '+242', name: 'Congo', callingCode: 'CG' },
  { code: '+243', name: 'Congo, Dem. Rep. of', callingCode: 'CD' },
  { code: '+682', name: 'Cook Islands', callingCode: 'CK' },
  { code: '+506', name: 'Costa Rica', callingCode: 'CR' },
  { code: '+385', name: 'Croatia', callingCode: 'HR' },
  { code: '+53', name: 'Cuba', callingCode: 'CU' },
  { code: '+599', name: 'Curaçao', callingCode: 'CW' },
  { code: '+357', name: 'Cyprus', callingCode: 'CY' },
  { code: '+420', name: 'Czech Republic', callingCode: 'CZ' },


  { code: '+45', name: 'Denmark', callingCode: 'DK' },
  { code: '+253', name: 'Djibouti', callingCode: 'DJ' },
  { code: '+1 767', name: 'Dominica', callingCode: 'DM' },
  { code: '+1 809', name: 'Dominican Republic', callingCode: 'DO' },
  { code: '+1 829', name: 'Dominican Republic', callingCode: 'DO' },
  { code: '+1 849', name: 'Dominican Republic', callingCode: 'DO' },


  { code: '+670', name: 'East Timor (Former Portuguese Timor)', callingCode: 'TP' },
  { code: '+593', name: 'Ecuador', callingCode: 'EC' },
  { code: '+20', name: 'Egypt', callingCode: 'EG' },
  { code: '+503', name: 'El Salvador', callingCode: 'SV' },
  { code: '+240', name: 'Equatorial Guinea', callingCode: 'GQ' },
  { code: '+291', name: 'Eritrea', callingCode: 'ER' },
  { code: '+372', name: 'Estonia', callingCode: 'EE' },
  { code: '+251', name: 'Ethiopia', callingCode: 'ET' },


  { code: '+500', name: 'Falkland Islands (Islas Malvinas)', callingCode: 'FK' },
  { code: '+298', name: 'Faroe Islands', callingCode: 'FO' },
  { code: '+679', name: 'Fiji', callingCode: 'FJ' },
  { code: '+358', name: 'Finland', callingCode: 'FI' },
  { code: '+33', name: 'France', callingCode: 'FR' },
  { code: '+594', name: 'French Guiana', callingCode: 'GF' },
  { code: '+689', name: 'French Polynesia', callingCode: 'PF' },


  { code: '+241', name: 'Gabon (Gabonese Republic)', callingCode: 'GA' },
  { code: '+220', name: 'Gambia', callingCode: 'GM' },
  { code: '+995', name: 'Georgia', callingCode: 'GE' },
  { code: '+49', name: 'Germany', callingCode: 'DE' },
  { code: '+233', name: 'Ghana', callingCode: 'GH' },
  { code: '+350', name: 'Gibraltar', callingCode: 'GI' },
  { code: '+30', name: 'Greece', callingCode: 'GR' },
  { code: '+299', name: 'Greenland', callingCode: 'GL' },
  { code: '+1 473', name: 'Grenada', callingCode: 'GD' },
  { code: '+590', name: 'Guadeloupe', callingCode: 'GP' },
  { code: '+1 671', name: 'Guam', callingCode: 'GU' },
  { code: '+502', name: 'Guatemala', callingCode: 'GT' },
  { code: '+224', name: 'Guinea', callingCode: 'GN' },
  { code: '+245', name: 'Guinea-Bissau', callingCode: 'GW' },
  { code: '+592', name: 'Guyana', callingCode: 'GY' },


  { code: '+509', name: 'Haiti', callingCode: 'HT' },
  { code: '+504', name: 'Honduras', callingCode: 'HN' },
  { code: '+852', name: 'Hong Kong', callingCode: 'HK' },
  { code: '+36', name: 'Hungary', callingCode: 'HU' },


  { code: '+354', name: 'Iceland', callingCode: 'IS' },
  { code: '+91', name: 'India', callingCode: 'IN' },
  { code: '+62', name: 'Indonesia', callingCode: 'ID' },
  { code: '+98', name: 'Iran', callingCode: 'IR' },
  { code: '+964', name: 'Iraq', callingCode: 'IQ' },
  { code: '+353', name: 'Ireland', callingCode: 'IE' },
  { code: '+972', name: 'Israel', callingCode: 'IL' },
  { code: '+39', name: 'Italy', callingCode: 'IT' },
  { code: '+225', name: 'Ivory Coast', callingCode: 'CI' },


  { code: '+1 876', name: 'Jamaica', callingCode: 'JM' },
  { code: '+81', name: 'Japan', callingCode: 'JP' },
  { code: '+962', name: 'Jordan', callingCode: 'JO' },


  { code: '+7 6', name: 'Kazakhstan', callingCode: 'KZ' },
  { code: '+254', name: 'Kenya', callingCode: 'KE' },
  { code: '+686', name: 'Kiribati', callingCode: 'KI' },
  { code: '850', name: 'Korea, Democratic Peoples Republic of (North Korea)', callingCode: '	KP' },
  { code: '82', name: 'Korea, Republic of (South Korea)', callingCode: 'KR' },
  { code: '+383', name: 'Kosovo', callingCode: 'XK' },
  { code: '+965', name: 'Kuwait', callingCode: 'KW' },
  { code: '+996', name: 'Kyrgyzstan', callingCode: 'KG' },


  { code: '+856', name: 'Laos', callingCode: 'LA' },
  { code: '+371', name: 'Latvia', callingCode: 'LV' },
  { code: '+961', name: 'Lebanon', callingCode: 'LB' },
  { code: '+266', name: 'Lesotho', callingCode: 'LS' },
  { code: '+231', name: 'Liberia', callingCode: 'LR' },
  { code: '+218', name: 'Libya', callingCode: 'LY' },
  { code: '+423', name: 'Liechtenstein', callingCode: 'LI' },
  { code: '+370', name: 'Lithuania', callingCode: 'LT' },
  { code: '+352', name: 'Luxembourg', callingCode: 'LU' },


  { code: '+853', name: 'Macau', callingCode: 'MO' },
  { code: '+389', name: 'Macedonia, The Former Yugoslav Republic of', callingCode: 'MK' },
  { code: '+261', name: 'Madagascar', callingCode: 'MG' },
  { code: '+265', name: 'Malawi', callingCode: 'MW' },
  { code: '+60', name: 'Malaysia', callingCode: 'MY' },
  { code: '+960', name: 'Maldives', callingCode: 'MV' },
  { code: '+223', name: 'Mali', callingCode: 'ML' },
  { code: '+356', name: 'Malta', callingCode: 'MT' },
  { code: '+692', name: 'Marshall Islands', callingCode: 'MH' },
  { code: '+596', name: 'Martinique (French)', callingCode: 'MQ' },
  { code: '+222', name: 'Mauritania', callingCode: 'MR' },
  { code: '+230', name: 'Mauritius', callingCode: 'MU' },
  { code: '+52', name: 'Mexico', callingCode: 'MX' },  		
  { code: '+269', name: 'Mayotte (Territorial Collectivity of Mayotte)', callingCode: 'YT' },
  { code: '+691', name: 'Micronesia', callingCode: 'FM' },
  { code: '+373', name: 'Moldova', callingCode: 'MD' },
  { code: '+377', name: 'Monaco', callingCode: 'MC' },
  { code: '+976', name: 'Mongolia', callingCode: 'MN' }, 		
  { code: '+663', name: 'Montserrat', callingCode: 'MS' },
  { code: '+382', name: 'Montenegro', callingCode: 'ME' },
  { code: '+212', name: 'Morocco', callingCode: 'MA' },
  { code: '+258', name: 'Mozambique', callingCode: 'MZ' },
  { code: '+95', name: 'Myanmar', callingCode: 'MM' },


  { code: '+264', name: 'Namibia', callingCode: 'NA' },
  { code: '+674', name: 'Nauru', callingCode: 'NR' },
  { code: '+977', name: 'Nepal', callingCode: 'NP' },
  { code: '+31', name: 'Netherlands', callingCode: 'NL' },     
  { code: '+599', name: 'Netherlands Antilles (Former Curacao and Dependencies)', callingCode: 'AN' },
  { code: '+687', name: 'New Caledonia', callingCode: 'NC' },
  { code: '+64', name: 'New Zealand (Aotearoa)', callingCode: 'NZ' },
  { code: '+505', name: 'Nicaragua', callingCode: 'NI' },
  { code: '+227', name: 'Niger', callingCode: 'NE' },
  { code: '+234', name: 'Nigeria', callingCode: 'NG' },
  { code: '+683', name: 'Niue (Former Savage Island)', callingCode: 'NU' },
  { code: '+672', name: 'Norfolk Island', callingCode: 'NF' },
  { code: '+669', name: 'Northern Mariana Islands', callingCode: 'MP' },
  { code: '+850', name: 'North Korea', callingCode: 'KP' },
  { code: '+47', name: 'Norway', callingCode: 'NO' },

  { code: '+968', name: 'Oman', callingCode: 'OM' },


  { code: '+92', name: 'Pakistan', callingCode: 'PK' },
  { code: '+680', name: 'Palau', callingCode: 'PW' },
  { code: '+970', name: 'Palestine', callingCode: 'PS' },
  { code: '+507', name: 'Panama', callingCode: 'PA' },
  { code: '+675', name: 'Papua New Guinea', callingCode: 'PG' },
  { code: '+595', name: 'Paraguay', callingCode: 'PY' },
  { code: '+51', name: 'Peru', callingCode: 'PE' },
  { code: '+63', name: 'Philippines', callingCode: 'PH' },
  { code: '+48', name: 'Poland', callingCode: 'PL' },
  { code: '+351', name: 'Portugal', callingCode: 'PT' },
  { code: '+1-787 or +1-939', name: 'Puerto Rico', callingCode: 'PR' },


  { code: '+974', name: 'Qatar', callingCode: 'QA' },


  { code: '+262', name: 'Reunion (French) (Former Bourbon Island)', callingCode: 'RE' },
  { code: '+40', name: 'Romania', callingCode: 'RO' },
  { code: '+7', name: 'Russia', callingCode: 'RU' },
  { code: '+250', name: 'Rwanda', callingCode: 'RW' },


  { code: '+590', name: 'Saint Barthélemy', callingCode: 'BL' },
  { code: '+290', name: 'Saint Helena, Ascension and Tristan da Cunha', callingCode: 'SH' },
  { code: '+1 869', name: 'Saint Kitts and Nevis', callingCode: 'KN' },
  { code: '+1 758', name: 'Saint Lucia', callingCode: 'LC' },
  { code: '+590', name: 'Saint Martin (French part)', callingCode: 'MF' },
  { code: '+508', name: 'Saint Pierre and Miquelon', callingCode: 'PM' },
  { code: '+1 784', name: 'Saint Vincent and the Grenadines', callingCode: 'VC' },
  { code: '+685', name: 'Samoa', callingCode: 'WS' },
  { code: '+378', name: 'San Marino', callingCode: 'SM' },
  { code: '+239', name: 'Sao Tome and Principe', callingCode: 'ST' },
  { code: '+966', name: 'Saudi Arabia', callingCode: 'SA' },
  { code: '+221', name: 'Senegal', callingCode: 'SN' },
  { code: '+381', name: 'Serbia', callingCode: 'RS' },
  { code: '+248', name: 'Seychelles', callingCode: 'SC' },
  { code: '+232', name: 'Sierra Leone', callingCode: 'SL' },
  { code: '+65', name: 'Singapore', callingCode: 'SG' },
  { code: '+1 721', name: 'Sint Maarten (Dutch part)', callingCode: 'SX' },
  { code: '+421', name: 'Slovakia', callingCode: 'SK' },
  { code: '+386', name: 'Slovenia', callingCode: 'SI' },
  { code: '+677', name: 'Solomon Islands', callingCode: 'SB' },
  { code: '+252', name: 'Somalia', callingCode: 'SO' },
  { code: '+27', name: 'South Africa', callingCode: 'ZA' },
  { code: '+82', name: 'South Korea', callingCode: 'KR' },
  { code: '+211', name: 'South Sudan', callingCode: 'SS' },
  { code: '+34', name: 'Spain', callingCode: 'ES' },
  { code: '+94', name: 'Sri Lanka', callingCode: 'LK' },
  { code: '+249', name: 'Sudan', callingCode: 'SD' },
  { code: '+597', name: 'Suriname', callingCode: 'SR' },
  { code: '+47', name: 'Svalbard and Jan Mayen', callingCode: 'SJ' },
  { code: '+268', name: 'Swaziland', callingCode: 'SZ' },
  { code: '+46', name: 'Sweden', callingCode: 'SE' },
  { code: '+41', name: 'Switzerland', callingCode: 'CH' },
  { code: '+963', name: 'Syrian Arab Republic', callingCode: 'SY' },


  { code: '+886', name: 'Taiwan', callingCode: 'TW' },
  { code: '+992', name: 'Tajikistan', callingCode: 'TJ' },
  { code: '+255', name: 'Tanzania', callingCode: 'TZ' },
  { code: '+66', name: 'Thailand', callingCode: 'TH' },
  { code: '+670', name: 'Timor-Leste', callingCode: 'TL' },
  { code: '+228', name: 'Togo', callingCode: 'TG' },
  { code: '+690', name: 'Tokelau', callingCode: 'TK' },
  { code: '+676', name: 'Tonga', callingCode: 'TO' },
  { code: '+1868', name: 'Trinidad and Tobago', callingCode: 'TT' },
  { code: '+216', name: 'Tunisia', callingCode: 'TN' },
  { code: '+90', name: 'Turkey', callingCode: 'TR' },
  { code: '+993', name: 'Turkmenistan', callingCode: 'TM' },
  { code: '+1649', name: 'Turks and Caicos Islands', callingCode: 'TC' },
  { code: '+263', name: 'Tuvalu (Former Ellice Islands)', callingCode: 'ZW' },


  { code: '+256', name: 'Uganda, Republic of', callingCode: 'UG' },
  { code: '+380', name: 'Ukraine', callingCode: 'UA' },
  { code: '+971', name: 'United Arab Emirates', callingCode: 'AE' },
  { code: '+44', name: 'United Kingdom', callingCode: 'GB' },
  { code: '+1', name: 'United States', callingCode: 'US' },
  { code: '+598', name: 'Uruguay', callingCode: 'UY' },
  { code: '+998', name: 'Uzbekistan', callingCode: 'UZ' },


  { code: '+678', name: 'Vanuatu (Former New Hebrides)', callingCode: 'VU' },
  { code: '+418', name: 'Vatican City State (Holy See)', callingCode: 'VA' },
  { code: '+58', name: 'Venezuela', callingCode: 'VE' },
  { code: '+84', name: 'Vietnam', callingCode: 'VN' },
  { code: '+1 284', name: 'British Virgin Islands', callingCode: 'VG' },
  { code: '+1 340', name: 'U.S. Virgin Islands', callingCode: 'VI' },


  { code: '+681', name: 'Wallis and Futuna Islands', callingCode: 'WF' },


  { code: '+967', name: 'Yemen', callingCode: 'YE' },


  { code: '+260', name: 'Zambia, Republic of (Former Northern Rhodesia)', callingCode: 'ZM' },
  { code: '+255', name: 'Zimbabwe, Republic of (Former Southern Rhodesia, Rhodesia)', callingCode: 'TZ' },

  ];
  const countryhandleChange = (event) => {
    setSelectedCountry(event.target.value);
  };
  
  
  const images = [
    "https://www.apitier.com/static/logo/facebook.png",

    "https://www.apitier.com/static/logo/youtube.png",

    "https://www.apitier.com/static/logo/instagram.png",

    "https://www.apitier.com/static/logo/wechat.png",

    "https://www.apitier.com/static/logo/tiktok.png",

    "https://www.apitier.com/static/logo/facebook-messenger.png",

    "https://www.apitier.com/static/logo/whatsapp.png",

    "https://www.apitier.com/static/logo/snapchat.png",

    "https://www.apitier.com/static/logo/telegram.png",

    "https://www.apitier.com/static/logo/pinterest.png",

    "https://www.apitier.com/static/logo/twitter.png",

    "https://www.apitier.com/static/logo/reddit.png",

    "https://www.apitier.com/static/logo/linkedin.png",

    "https://www.apitier.com/static/logo/quora.png",

    "https://www.apitier.com/static/logo/gmail.png",

    "https://www.apitier.com/static/logo/phone.png",

    "https://www.apitier.com/static/logo/wifi.png",

    "https://www.apitier.com/static/logo/shopify.png",

    "https://www.apitier.com/static/logo/googleplay.png",

    "https://www.apitier.com/static/logo/google-plus.png",

    "https://www.apitier.com/static/logo/spotify.png",

    "https://www.apitier.com/static/logo/share.png",

    "https://www.apitier.com/static/logo/bitcoin.png",

    "https://www.apitier.com/static/logo/sms.png",

    "https://www.apitier.com/static/logo/link.png",

    "https://www.apitier.com/static/logo/phonecall.png",

    "https://www.apitier.com/static/logo/location.png",

    "https://www.apitier.com/static/logo/skype.png",

    "https://www.apitier.com/static/logo/event.png",

    "https://www.apitier.com/static/logo/paypal.png",

    "https://www.apitier.com/static/logo/text.png",

    "https://www.apitier.com/static/logo/zoom.png",  

    "https://www.apitier.com/static/logo.png", 
  ];

  const [selectedImage, setSelectedImage] = useState();

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleClearImage = () => {
    setSelectedImage(null);
  }

  const handleUploadImage = () => {
    const confirmed = window.confirm("Please Sign Up for the API for the advance features!!");
    if (confirmed) {
      window.open('https://www.apitier.com/signup', '_blank');
    }
  };

  useEffect(() => {
    generateqrCode(text, light, dark, selectedImage)
  }, []);

  const handleDownloadQRCodeEvent = () => {
    track.event('download_qrcode_apitier');
  }
  const handleGenerateQRCodeEvent = () => {
    track.event('generate_qrcode_apitier');
  }
  const redirectAIQRCodeEvent = () => {
    track.event('redirect_aiqrcodes_from_apitier');
  }


  const downloadqrCode = async () => {
    try {
      handleDownloadQRCodeEvent();

      const link = document.createElement('a')
      link.href = img;
      link.download = 'whatsapp_qrcode.png'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

    } catch (err) {
      console.error(err);
    }
  };

  const generateqrCode = async (text, light, dark, selectedImage) => {

    try { 
      handleGenerateQRCodeEvent();

      const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
          "text": text,
          "width": 150,
          "height": 150,
          "options": {
            "colorLight": light,
            "colorDark": dark,
            "logo": selectedImage,
            "logoBackgroundColor": "#ffffff",
          }
        })
      }

      const res = await fetch(dashboardApiConfig.dashboard_barcode_api_url + '/generate/qrcode?x-api-key=' + dashboardApiConfig.dashboard_barcode_api_demo_key, requestOptions);
      const imageBlob = await res.blob();
      const imageObjectURL = URL.createObjectURL(imageBlob);
      setImg(imageObjectURL);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      spacing={3}
      {...rest}
    >
      <Grid
        item
        lg={8}
        md={6}
        xl={9}
        xs={12}
      >

        <Formik
          enableReinitialize
          initialValues={{
            name: '+44 8568768711',
            message:'Message',
            country:'GB United Kingdom (+44)',
            customlogo: selectedImage,
            submit: null
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string().max(255).required('Please enter whatsapp phone number to generate qrcode'),
            message: Yup.string().max(255).required('Please enter message to generate qrcode'),
            country: Yup.string().max(255).required('Please select country code to generate qrcode'),
            colorlight: Yup.string().max(255),
            colordark: Yup.string().max(255),
            customlogo: Yup.string().max(255),
          })}
          onSubmit={async (values, {
            resetForm,
            setErrors,
            setStatus,
            setSubmitting
          }) => {
            try {
              // NOTE: Make API request
              generateqrCode(`country_name:${selectedCountry}whatsapp_number:${values.name}whatsapp_message:${values.message}`, 
                              light, dark, selectedImage)

              await wait(200);
              resetForm();
              setStatus({ success: true });
              setSubmitting(false);
            } catch (err) {
              console.error(err);
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values
          }) => (
            <form onSubmit={handleSubmit}>
              <Card
                className={clsx(classes.root, className)}
                {...rest}
              >
          
  
            <Typography
              variant="h2"
              align="left"
              color="textPrimary"
            >
              

              <br /> 
              Generate Free QRCode For {qrcodeName} !!

            </Typography>
          <CardHeader  >



          </CardHeader>
          <Divider />

        <Accordion expanded={expanded === 'expand_whatsapp'} onChange={whatsapp_accordioan('expand_whatsapp')}>
            <AccordionSummary expandIcon={<ExpandMore />} aria-controls="expand_whatsapp_content" id="expand_whatsapp_header">
                <Typography>ENTER WHATSAPP DETAILS </Typography>
            </AccordionSummary>
              <AccordionDetails>
                  <CardContent>
                  <Grid
                  container
                  >
                  <Grid
                    item
                    md={20}
                    xs={12}
                  >

                <FormControl fullWidth>
                  <InputLabel id="country-label">Country</InputLabel>
                  <Select
                    labelId="country-label"
                    id="country"
                    value={selectedCountry}
                    label="Country"
                    onChange={countryhandleChange}
                  >
                    {countries.map((country) => (
                      <MenuItem key={country.name} value={country.name}>
                        {`${country.callingCode} ${country.name} (${country.code})`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                  
                  </Grid>
                </Grid>


              <br /><br />  
              
              <Grid
                container
              >
                <Grid
                  item
                  md={20}
                  xs={12}
                >
                  <StyledTextField 
                    error={Boolean(touched.name && errors.name)}
                    fullWidth
                    helperText={touched.name && errors.name}
                    label="Enter Phone Number"
                    name="name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.name}
                    variant="outlined"
                  />
                </Grid>
              </Grid>

              <br /><br />  

              <Grid
              container
            >
              <Grid
                item
                md={20}
                xs={12}
              >
                <StyledTextField 
                  error={Boolean(touched.message && errors.message)}
                  fullWidth
                  helperText={touched.message && errors.message}
                  label="Enter Message"
                  name="message"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.message}
                  variant="outlined"
                />
              </Grid>
            </Grid>

            {errors.submit && (
              <Box mt={3}>
                <FormHelperText error>
                  {errors.submit}
                </FormHelperText>
              </Box>
            )}
                </CardContent>
            </AccordionDetails>
       </Accordion>

          <br />

          <Accordion >
                <AccordionSummary expandIcon={<ExpandMore />} aria-controls="expand_url_content" id="expand_url_header">
                    <Typography>CHOOSE COLORS</Typography>
                </AccordionSummary>
                  <AccordionDetails>
                      <CardContent>

            <Typography><b>COLORLIGHT</b></Typography>
            <Paper className={classes.paper}>
            <input   
              variant="contained"  
              style={{ margin: "0px 17px" }}
              type="color"
              value={light}
              onChange={e => setLight(e.target.value)} 
            />

            <Divider className={classes.divider} orientation="vertical" />

            <TextField
                label="COLORLIGHT"
                margin="normal"
                type="name"
                variant="outlined"
                style={{ margin: "0px 5px" }}
                size="small"
                placeholder="#ffffff"
                value={light} 
              />

            </Paper>
            <br /><br />
            <Typography><b>COLORLDARK</b></Typography>
            <Paper className={classes.paper}>
            <input   
              variant="contained"  
              style={{ margin: "0px 17px" }}
              type="color"
              value={dark}
              onChange={e => setDark(e.target.value)} 
            />

            <Divider className={classes.divider} orientation="vertical" />

            <TextField
                label="COLORLDARK"
                margin="normal"
                type="text"
                variant="outlined"
                style={{ margin: "0px 5px" }}
                size="small"
                placeholder="#050505"
                value={dark} 
              />

            </Paper>
                    </CardContent>
                </AccordionDetails>
          </Accordion>

        <br />

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />} aria-controls="expand_url_content" id="expand_url_header">
              <Typography>SET CUSTOM LOGO</Typography>
          </AccordionSummary>
            <AccordionDetails>
              <CardContent>

              {selectedImage && (
                      <div style={{ border: '1px solid grey', padding: '10px', width: '110px', height: '110px' }}>
                        <img src={selectedImage} alt="" style={{ maxWidth: '105%' }} />
                        
                        <Box sx={{ position: 'absolute', top: 100, left: 190 }}>
                          <Button 
                          variant="contained" 
                          color="secondary"  
                          onClick={handleUploadImage}
                          >
                            Upload Image
                          </Button>
                        </Box>

                        <Box sx={{ position: 'absolute', top: 150, left: 190 }}>
                          <Button 
                          variant="contained" 
                          color="secondary" 
                          onClick={handleClearImage} >
                            Remove Image
                          </Button>
                        </Box>
                        </div>
                      )}

                      <br />
                      
                      <Grid container spacing={2}>
                        {images.map((imageUrl) => (
                          <Grid item xs={6} sm={1} key={imageUrl}>
                            <img
                              src={imageUrl}
                              alt=""
                              style={{ width: '100%', cursor: 'pointer' }}
                              onClick={() => handleImageClick(imageUrl)}
                            />
                          </Grid>
                        ))}
                      </Grid>
                      
              </CardContent>
        </AccordionDetails>
        </Accordion>

          <br />
          <Divider />

          <Box
                  p={2}
                  display="flex"
                  justifyContent="flex-end"
                >
                  <Button
                    color="secondary"
                    disabled={isSubmitting}
                    type="submit"
                    variant="contained"
                  >
                    Generate QRCode
                  </Button>
                </Box>
     
              </Card>
            </form>
          )}
        </Formik>

      </Grid>
      <Grid
        item
        lg={4}
        md={6}
        xl={3}
        xs={12}
      >
        <Card
          className={clsx(classes.root, className)}
          {...rest}
        >
          <CardContent>
            <Box
              display="flex"
              alignItems="center"
              flexDirection="column"
              textAlign="center"
            >

              <img src={img} />
            </Box>
          </CardContent>
          <CardActions>

            <Button
              fullWidth
              alignItems="center"
              variant="contained"
              color="secondary"
              onClick={downloadqrCode}
            >
              Download QRCode
            </Button>
          </CardActions>
          <Divider />
            <Box
              p={2}
              display="flex"
              justifyContent="flex-end"
              >
            <Button
                      fullWidth
                      alignItems="center"
                      variant="contained"
                      color="secondary"
                      component={RouterLink}
                      to={{ pathname: "https://ai.qrcodes.apitier.com" }}
                      target="_blank"
                      onClick={redirectAIQRCodeEvent}
                    >
                      Get Artistic QR Code
              </Button>
                  
            </Box>
        </Card>
      </Grid>
    </Grid>
  );
}




WhatsappQRCode.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  format: PropTypes.string,
  qrcodeName: PropTypes.string

};

export default WhatsappQRCode;







